// Configuration for the admin console - follows same pattern as frontend
interface AdminConfig {
  apiUrl: string
  frontendUrl: string
  oauthGoogleClientId: string
  oauthGoogleCallbackPath: string
  environment: string
}

const baseConfig = {
  oauthGoogleClientId: "593821398156-un1jrmunlse3dj4964b8o4jafu328bpg.apps.googleusercontent.com",
  oauthGoogleCallbackPath: "/v1/oauth/google/callback",
}

const localConfig: AdminConfig = {
  ...baseConfig,
  frontendUrl: import.meta.env.VITE_FRONTEND_URL,
  apiUrl: "http://localhost:8787",
  environment: "local",
}

const localRemoteConfig: AdminConfig = {
  ...baseConfig,
  frontendUrl: import.meta.env.VITE_FRONTEND_URL,
  apiUrl: "http://localhost:8787",
  environment: "localRemote",
}

const devConfig: AdminConfig = {
  ...baseConfig,
  frontendUrl: "https://dev.playside.co",
  oauthGoogleClientId: "593821398156-un1jrmunlse3dj4964b8o4jafu328bpg.apps.googleusercontent.com",
  apiUrl: "https://api-dev.playside.co",
  environment: "dev",
}

const prodConfig: AdminConfig = {
  ...baseConfig,
  frontendUrl: "https://playside.co",
  oauthGoogleClientId: "593821398156-oeh380dgq55q569mvnl6ossk3n8t9guu.apps.googleusercontent.com",
  apiUrl: "https://api.playside.co",
  environment: "prod",
}

// Get environment from Cloudflare or fallback to local
const environment = import.meta.env.CLOUDFLARE_ENV || "local"
const backendEnv = import.meta.env.VITE_BACKEND_ENV || null

let config: AdminConfig

if (environment === "dev") {
  config = devConfig
} else if (environment === "prod" || environment === "production") {
  config = prodConfig
} else if (environment === "localRemote") {
  config = localRemoteConfig
} else {
  // Check backend environment for local:remote setup
  if (backendEnv === "localRemote") {
    config = localRemoteConfig
  } else {
    config = localConfig
  }
}

// Allow environment variable overrides
if (import.meta.env.VITE_API_URL) {
  config.apiUrl = import.meta.env.VITE_API_URL
}

if (import.meta.env.VITE_OAUTH_GOOGLE_CLIENT_ID) {
  config.oauthGoogleClientId = import.meta.env.VITE_OAUTH_GOOGLE_CLIENT_ID
}

export default config
